import { createTheme, Theme } from '@material-ui/core';
import { Overrides } from '@material-ui/core/styles/overrides';

import { buttonOverrides } from './Button';
import { dialogOverrides } from './Dialog';
import { dialogContentOverrides } from './DialogContent';
import { formOverrides } from './Form';
import { formHelperTextOverrides } from './FormHelperText';
import { linkOverrides } from './Link';
import { listItemOverrides } from './ListItem';
import { listItemIconOverrides } from './ListItemIcon';
import { radioOverrides } from './Radio';
import { scopedCssBaselineOverrides } from './ScopedCssBaseline';
import { selectOverrides } from './Select';
import { typographyOverrides } from './Typography';

export const overrides: Overrides = {
  ...scopedCssBaselineOverrides,
  ...buttonOverrides,
  ...dialogContentOverrides,
  ...dialogOverrides,
  ...listItemIconOverrides,
  ...typographyOverrides,
  ...formHelperTextOverrides,
  ...linkOverrides,
  ...radioOverrides,
  ...selectOverrides,
  ...listItemOverrides,
  ...formOverrides
};

export const globalMuiTheme: Theme = createTheme({
  overrides
});
